import React, {useCallback, useEffect, useState} from "react";
import {useEventListener} from "../../../infrastructure/hooks/useEventListener";
import {KEY_CODES} from "../../../core/consts";
import {observer} from "mobx-react";

export const NewSearchWidgetRecentKeyboardClickComposer = (Widget) => observer(({controller}) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {
    isListSingleView,
    recentSearchListModel,
    isRecentSearchedActiveNavigation,
    isRecentSearchedHighlighted
  } = state;

  const [highlightedItemIndex, setHighlightedItemIndex] = useState(0);

  useEffect(() => {
    if (isRecentSearchedHighlighted) {
      setHighlightedItemIndex(0)
    } else if (!isRecentSearchedActiveNavigation) {
      setHighlightedItemIndex(null)
    }
  }, [isRecentSearchedActiveNavigation]);

  const onKeyboardClick = useCallback((event) => {
    if (!isSmallView) {
      if (isRecentSearchedActiveNavigation) {
        const {keyCode} = event;
        const {down, up, left, right, tab} = KEY_CODES;

        if ([down, up].includes(keyCode)) {
          event.preventDefault()

          const entitiesLength: Number = recentSearchListModel?.entities?.length;

          if (entitiesLength > 0 && keyCode === down) {
            const nextItem: Number = (highlightedItemIndex + 1).mod(entitiesLength);
            setHighlightedItemIndex(nextItem);
          } else if (highlightedItemIndex !== 0 && entitiesLength > 0 && keyCode === up) {
            const previewItem: Number = (highlightedItemIndex - 1).mod(entitiesLength);
            setHighlightedItemIndex(previewItem);
          } else {
            setHighlightedItemIndex(0)
          }
        } else if ([left, right].includes(keyCode)) {
          event.preventDefault()
        } else if (tab === keyCode) {
          setHighlightedItemIndex(0)
        }
      }
    }
  });

  useEventListener('keydown', onKeyboardClick);

  const newProps = {
    controller,
    highlightedItemIndex,
    setHighlightedItemIndex
  };


  if (isListSingleView) {
    return null
  }

  return <Widget {...newProps}/>;
});
